import React from "react";
import BackgroundImage from "../../../assets/img/Background/bg-food.jpg";
import Container from "../../elements/Container";
import Header from "./Header";
import Product from "../../../assets/img/HeroTop/burger-hero-top.png";
import Button from "../../elements/Button";

export default function HeroTop() {
   return (
      <div className="bg-primary w-full">
         <div
            className="bg-repeat w-full h-full pb-10 md:pb-40"
            style={{ backgroundImage: `url(${BackgroundImage})` }}
         >
            <Container>
               <Header />
               <div className="w-full relative">
                  {/* Illustration */}
                  <img
                     src={Product}
                     alt="Menu Burger, frites, boisson"
                     className="hidden lg:block lg:absolute right-0 -top-72 w-7/12 z-0"
                  />
                  {/* Pricing */}
                  <div className="hidden lg:block lg:absolute rounded-full bg-red-custom p-3 w-40 h-40 right-96 top-52">
                     <div className="rounded-full w-full h-full border-2 border-dashed text-white flex items-center justify-center">
                        <div className="text-center">
                           <span className="text-3xl block font-bold">
                              <span className="text-5xl">5</span>.49€
                           </span>
                           <span className="uppercase font-semibold">
                              seulement
                           </span>
                        </div>
                     </div>
                  </div>
                  {/* Textes */}
                  <div className="text-secondary z-10 relative mt-5 md:mt-28 text-center md:text-start">
                     <h1 className="uppercase tracking-tight text-xl md:text-2xl mb-3 font-secondary">
                        Pour les vrais amateurs de hamburgers.
                     </h1>
                     <h2 className="uppercase tracking-tighter font-title shadowTitle">
                        <span className="text-7xl md:text-8xl block">Burger</span>
                        <span className="text-5xl block md:inline">House</span>
                        <span className="text-4xl md:ml-3">
                           Click<span className="text-red-custom">&</span>
                           Collect
                        </span>
                     </h2>
                  </div>
               </div>
               <Button
                  className={"mt-5 rounded-sm block mx-auto md:inline md:text-start"}
                  color="secondary"
                  theme="big"
               >
                  Créer mon compte
               </Button>
            </Container>
         </div>
      </div>
   );
}
